// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * OpenSeadragon paperjs overlay plugin based on paper.js
 * @version 0.7.6
 * 
 * Includes additional open source libraries which are subject to copyright notices
 * as indicated accompanying those segments of code.
 * 
 * Original code:
 * Copyright (c) 2022-2026, Thomas Pearce
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 * 
 * * Redistributions of source code must retain the above copyright notice, this
 *   list of conditions and the following disclaimer.
 * 
 * * Redistributions in binary form must reproduce the above copyright notice,
 *   this list of conditions and the following disclaimer in the documentation
 *   and/or other materials provided with the distribution.
 * 
 * * Neither the name of osd-paperjs-annotation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * 
 */
.osd-paperjs-annotation .editablecontent{
    display:grid;
    grid-template-columns:1fr auto;
}
.osd-paperjs-annotation .editablecontent:not(.editing){
    cursor:default;
}

.osd-paperjs-annotation .editablecontent>.edit-button{
    margin-left:0.2em;
    cursor:pointer;
}
.osd-paperjs-annotation .editablecontent:not(:hover) .onhover{
    visibility:hidden;
}
.osd-paperjs-annotation .editablecontent.editing .text-content{
    display: none;
}
.osd-paperjs-annotation .editablecontent.editing textarea{
    display:block;
}
.osd-paperjs-annotation .editablecontent:not(.editing) textarea{
    display:none;
}

.osd-paperjs-annotation .editablecontent .text-content{
    display:inline-block;
    position:relative;
}
.osd-paperjs-annotation .editablecontent svg *{
    pointer-events: none;
}
.osd-paperjs-annotation .editablecontent textarea{
    resize:none;
    width:100%;
    padding:0;
    margin:0;
    border:none;
    outline:thin black solid;
    font-weight: inherit;
    font-size: inherit;
    font-family: inherit;
}`, "",{"version":3,"sources":["webpack://./src/css/editablecontent.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAoCE;AACF;IACI,YAAY;IACZ,8BAA8B;AAClC;AACA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,UAAU;IACV,SAAS;IACT,QAAQ;IACR,WAAW;IACX,wBAAwB;IACxB,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;AACxB","sourcesContent":["/**\n * OpenSeadragon paperjs overlay plugin based on paper.js\n * @version 0.7.6\n * \n * Includes additional open source libraries which are subject to copyright notices\n * as indicated accompanying those segments of code.\n * \n * Original code:\n * Copyright (c) 2022-2026, Thomas Pearce\n * All rights reserved.\n * \n * Redistribution and use in source and binary forms, with or without\n * modification, are permitted provided that the following conditions are met:\n * \n * * Redistributions of source code must retain the above copyright notice, this\n *   list of conditions and the following disclaimer.\n * \n * * Redistributions in binary form must reproduce the above copyright notice,\n *   this list of conditions and the following disclaimer in the documentation\n *   and/or other materials provided with the distribution.\n * \n * * Neither the name of osd-paperjs-annotation nor the names of its\n *   contributors may be used to endorse or promote products derived from\n *   this software without specific prior written permission.\n * \n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\"\n * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE\n * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE\n * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL\n * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR\n * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER\n * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,\n * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n * \n */\n.editablecontent{\n    display:grid;\n    grid-template-columns:1fr auto;\n}\n.editablecontent:not(.editing){\n    cursor:default;\n}\n\n.editablecontent>.edit-button{\n    margin-left:0.2em;\n    cursor:pointer;\n}\n.editablecontent:not(:hover) .onhover{\n    visibility:hidden;\n}\n.editablecontent.editing .text-content{\n    display: none;\n}\n.editablecontent.editing textarea{\n    display:block;\n}\n.editablecontent:not(.editing) textarea{\n    display:none;\n}\n\n.editablecontent .text-content{\n    display:inline-block;\n    position:relative;\n}\n.editablecontent svg *{\n    pointer-events: none;\n}\n.editablecontent textarea{\n    resize:none;\n    width:100%;\n    padding:0;\n    margin:0;\n    border:none;\n    outline:thin black solid;\n    font-weight: inherit;\n    font-size: inherit;\n    font-family: inherit;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
